// Niestandardowe zdarzenie Pixela na przyciskach CTA (zgodne z konfiguracją
// z innych stron EduNation). location np. "header", "hero", "sticky-mobile".
export const trackClickCTA = (location) => {
    window.fbq?.("trackCustom", "ClickCTA", { location });
};
